<template>
  <div class="fourday" id="fourday">
    <!-- ps img -->
    <!-- <div class="con-imgs-box">
      <template v-for="(item,index) in 30">
        <div v-if="index===6" :key="index">
          <div class="shixue-p">
            <p class="shixue-title">秋季免费试学营</p>
            <p class="shixue-time">
              秋季三期：8月31日-9月4日
              <br />秋季四期：9月7日-9月11日
              <br />秋季五期：9月14日-9月18日
              <br />秋季六期：9月21日-9月25日
              <br />国庆试学：10月1日-10月7日
            </p>
          </div>
        </div>
        <div v-else-if="index===7" :key="index" style="display:none;">
        </div>
        <img v-else class="con-img" :src="getConImgUrl(item)" :key="index" @click="imgClick(index)" />
      </template>
    </div> -->
    <img :src="fourDayimg" alt="图片" />
  </div>
</template>
<script>
export default {
  name: "fourday",
  data() {
    return {
      msg: "fourday page",
      fourDayimg:
        "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/2024-02-20/zyky.jpg"
    };
  },
  methods: {
    getConImgUrl(item) {
      return require("../assets/img/fourday/fourday_ps_" +
        (item > 9 ? item + "" : "0" + item) +
        ".jpg");
    },
    imgClick(index) {
      if (index === 3000) {
        // doyoo.util.openChat('c=20001028&f=10055590&n=10058677');
        window.open(
          "http://chat.looyuoms.com/chat/chat/p.do?c=20001028&f=10055590&g=10058680"
        );
      }
      return false;
    },
  },
};
</script>
<style lang="less" scoped>
.fourday {
  width: 100%;
  img {
    width: 100%;
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    outline: none;
  }
}
.con-imgs-box {
  .shixue-p {
    font-size: 18px;
    .shixue-title {
      text-align: center;
      padding: 10px;
      font-weight: bold;
    }
    .shixue-time {
      padding-left: 25%;
      margin: 0 auto;
      text-align: left;
      line-height: 1.6;
    }
  }
  .con-img {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    outline: none;
  }
}
</style>
